import type { FieldType, IForecast } from '@/interfaces'

import { addToJSON } from './helper'

export class Forecast implements IForecast {
	[key: string]: FieldType
	id: number

	constructor({ id }: Partial<IForecast> = {}) {
		this.id = id || 0
		addToJSON(Forecast)
	}

	toJSON(): string {
		// this will be overridden by the addToJSON method
		return ''
	}
}
